import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Biography from './components/Biography';
import Books from './components/Books';
import Media from './components/Media';
import Newsletter from './components/Newsletter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Biography />
      <Books />
      <Media />
      <Newsletter />
      <Contact />
      <Footer />
    </div>
  );
}